import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { GETTERS as LEADERBOARD_GETTERS } from '@/store/leaderboard';
@Component({
  name: 'CmgLeaderboardLocations',
})
export default class CmgLeaderboardLocations extends Vue {

  get isInErrorState(): boolean {
    return this.$appStore.state.leaderboard.isInErrorState;
  }

  get orderCount(): number {
    return this.$appStore.getters[LEADERBOARD_GETTERS.ORDER_COUNT];
  }  

  get isInZeroState(): boolean {
    return this.orderCount === 0 || this.$appStore.state.leaderboard.statistics.nationalRankPercentage === 0;
  }
  
  get locations(): number {
      return this.$appStore.state.leaderboard.statistics.restaurantsVisited;
  }

  get restaurantUrl(): string {
    return this.$appStore.state.cms.images.loyalty.location.default;
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get whiteBoxImg(): string | undefined {
    return !this.isMobile
      ? this.$appStore.state.cms.images.loyalty.leaderboardWhiteBoxBadgesEarned.desktop
      : this.$appStore.state.cms.images.loyalty.leaderboardWhiteBoxBadgesEarned.mobile;
  }
}
